import React from "react";
import { Typography, Container, Paper, Box } from "@mui/material";

export default function CompanySpotlightPage() {
  return (
    <Container maxWidth="lg">
      <Paper sx={{ padding: 4, marginTop: 4 }}>
        <Typography variant="h4" gutterBottom>Company Spotlight</Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Featured company metrics across time, charted
        </Typography>
        <Box>
          <Typography variant="subtitle1" color="text.secondary">
            [Demo charts or tables would appear here based on GCS long-format financial data.]
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}